/* ============================================================
   TU Sticky Add-to-Cart bar engine (product pages only)
   Config seeded by snippets/tu-sticky-cart.liquid as window.__tuSticky.
   - Reveals itself once the page's real Add-to-cart button scrolls out of view.
   - Single product: mirrors the page price block (#price-<section>) + current variant image.
   - Kaching bundle: reflects the CURRENTLY SELECTED deal bar (title, item images, deal/RRP price).
   - Its button never adds directly — it CLICKS the page's real add button, so the existing
     add-to-cart interception (snippets/tu-cart-drawer.liquid) handles both normal + Kaching adds.
   ============================================================ */
(function () {
  'use strict';
  var D = window.__tuSticky;
  var root = document.getElementById('tu-sticky-atc');
  if (!D || !root) return;

  var mediaEl = root.querySelector('.tu-sticky__media');
  var titleEl = root.querySelector('.tu-sticky__title');
  var variantEl = root.querySelector('.tu-sticky__variant');
  var priceEl = root.querySelector('.tu-sticky__price');
  var btn     = root.querySelector('.tu-sticky__atc');
  var labelEl = root.querySelector('.tu-sticky__atc-label');
  var form       = document.getElementById(D.formId);
  var priceBlock = document.getElementById(D.priceId);

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  // The page's real Add-to-cart button (Dawn buy-buttons block / Kaching takes over the same form).
  function realBtn() { return form && (form.querySelector('[name="add"]') || form.querySelector('button[type="submit"]')); }
  function curVid()  { var i = form && form.querySelector('[name="id"]'); return i ? i.value : null; }

  // The Kaching deal bar the shopper currently has selected. Primary signal is the form's hidden
  // __kaching_bundles.bid (stable); falls back to the bar carrying the --selected class. Mirrors the
  // resolution used by assets/tu-cart.js so the sticky bar and the drawer agree on the selection.
  function selectedBar() {
    var bid = null, kp = document.querySelector('[name="properties[__kaching_bundles]"]');
    if (kp && kp.value) { try { var pj = JSON.parse(kp.value); bid = pj.bid || pj.bar; } catch (e) {} }
    var bar = bid ? document.querySelector('.kaching-bundles__bar[data-deal-bar-id="' + bid + '"]') : null;
    if (!bar) bar = document.querySelector('.kaching-bundles__bar--selected');
    return bar;
  }
  // Item count of a deal bar — >1 means a multi-item bundle (no single colour/size to state).
  function barSize(bar) {
    if (!bar) return 0;
    var slots = bar.querySelectorAll('.kaching-bundles__collection-product, .kaching-bundles__bundle-products__product, .kaching-bundles__product').length;
    var t = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent || '';
    var m = t.match(/^\s*(\d+)\b/);
    return Math.max(slots, m ? parseInt(m[1], 10) : 0);
  }

  function setMedia(srcs) {
    srcs = (srcs || []).filter(Boolean);
    if (!srcs.length) { mediaEl.innerHTML = ''; return; }
    var shown = srcs.slice(0, 3), extra = srcs.length - shown.length;
    mediaEl.innerHTML = shown.map(function (s, i) {
      return '<img class="tu-sticky__img" src="' + esc(s) + '" alt="" loading="lazy" style="z-index:' + (10 - i) + '">';
    }).join('') + (extra > 0 ? '<span class="tu-sticky__more">+' + extra + '</span>' : '');
    mediaEl.classList.toggle('tu-sticky__media--stack', srcs.length > 1);
  }

  // For a multi-item bundle, read each item's selected colour + size from the bar's variant rows,
  // e.g. "Midnight / M · Dawn / L" — so the bar states exactly what will be added.
  function bundleVariantText(bar) {
    var rows = [].slice.call(bar.querySelectorAll('.kaching-bundles__bar-variant-selects'));
    var parts = rows.map(function (r) {
      var sw = r.querySelector('.kaching-bundles__swatch-dropdown, [class*="swatch-dropdown"]');
      var sz = r.querySelector('select');
      var colour = sw ? (sw.getAttribute('data-value') || sw.textContent.replace(/\s+/g, ' ').trim()) : '';
      var size = sz ? sz.value : '';
      return [colour, size].filter(Boolean).join(' / ');
    }).filter(Boolean);
    return parts.join('  ·  ');
  }

  // Bundle mode: read the selected bar's title, deal price + RRP (strikethrough), and item images.
  function syncBundle(bar) {
    var t = bar.querySelector('.kaching-bundles__bar-title');
    titleEl.textContent = (t && t.textContent.trim()) || D.title;
    var dEl = bar.querySelector('.kaching-bundles__bar-price');
    var fEl = bar.querySelector('.kaching-bundles__bar-full-price');
    var deal = dEl ? dEl.textContent.trim() : '';
    var full = fEl ? fEl.textContent.trim() : '';
    priceEl.innerHTML = (full && full !== deal ? '<s class="tu-sticky__was">' + esc(full) + '</s> ' : '')
      + (deal ? '<span class="tu-sticky__now">' + esc(deal) + '</span>' : '');
    var imgs = [].slice.call(bar.querySelectorAll('.kaching-bundles__collection-product img, .kaching-bundles__bar-product img, .kaching-bundles__product img'));
    var srcs = imgs.map(function (im) { return im.getAttribute('src') || im.currentSrc; }).filter(Boolean);
    if (!srcs.length && D.img) srcs = [D.img];
    setMedia(srcs);
  }

  // Single-product mode: product title, mirrored page price, current variant image.
  function syncSingle() {
    titleEl.textContent = D.title;
    if (priceBlock) priceEl.innerHTML = priceBlock.innerHTML;
    var vid = curVid();
    var src = (vid && D.vimg && D.vimg[vid]) || D.img;
    setMedia([src]);
  }

  // Mirror the real button's label + disabled (sold out / unavailable) state onto the sticky button.
  function mirrorBtn() {
    var rb = realBtn();
    if (!rb) return;
    var sp = rb.querySelector('span');
    var txt = ((sp && sp.textContent) || rb.textContent || 'Add to cart').trim();
    if (labelEl && txt) labelEl.textContent = txt;
    btn.disabled = !!(rb.disabled || rb.getAttribute('aria-disabled') === 'true');
    // Match the main button's glow colour: it carries the campaign accent inline as --tu-accent
    // (flash = red, clearance, etc; unset = default green). Mirror it so the sticky glow matches.
    var acc = (rb.style.getPropertyValue('--tu-accent') || getComputedStyle(rb).getPropertyValue('--tu-accent') || '').trim();
    if (acc) root.style.setProperty('--tu-accent', acc);
    else root.style.removeProperty('--tu-accent');
  }
  // Keep that mirror LIVE: the real button is briefly disabled during a (Kaching) add, then re-enabled.
  // Without watching it, the sticky button could stay greyed after add → remove → close until reload.
  var btnObs = null, watchedBtn = null;
  function watchBtn() {
    var rb = realBtn();
    if (!rb || rb === watchedBtn) return;
    if (btnObs) { try { btnObs.disconnect(); } catch (e) {} }
    watchedBtn = rb;
    if (!btnObs) btnObs = new MutationObserver(mirrorBtn);
    try { btnObs.observe(rb, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'], childList: true, subtree: true }); } catch (e) {}
  }

  function sync() {
    var bar = selectedBar();
    if (bar) syncBundle(bar); else syncSingle();
    // State the colour/size that will be added — for the single/variant view only (a multi-item
    // bundle has no single variant, so it's left blank and described by its set title).
    if (variantEl) {
      var multi = bar && barSize(bar) > 1;
      if (multi) {
        variantEl.textContent = bundleVariantText(bar);
      } else {
        var vt = D.vtitle ? D.vtitle[curVid()] : '';
        variantEl.textContent = (vt && vt !== 'Default Title') ? vt : '';
      }
    }
    mirrorBtn();
    watchBtn();
    setupReveal();
  }

  // ---- Reveal (mobile + desktop alike) ----
  // The bar is revealed only once the page's real Add-to-cart button scrolls out of view, and hides
  // again when it's back on screen — so there's never a redundant duplicate button next to the real
  // one. While the bar is shown we set html.tu-sticky-on, which lets the CSS hide the chat launcher
  // (mobile) just for that window; when the bar hides, the launcher returns.
  var io = null, anchorEl = null;
  function show(on) {
    root.classList.toggle('tu-sticky--show', on);
    root.setAttribute('aria-hidden', on ? 'false' : 'true');
    document.documentElement.classList.toggle('tu-sticky-on', on);
  }
  function ensureAnchor() {
    var a = realBtn() || form || priceBlock;
    if (!a || a === anchorEl) return;
    if (!('IntersectionObserver' in window)) { show(true); return; }
    if (io && anchorEl) { try { io.unobserve(anchorEl); } catch (e) {} }
    anchorEl = a;
    if (!io) {
      io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.target === anchorEl) show(!e.isIntersecting); });
      }, { threshold: 0 });
    }
    io.observe(anchorEl);
  }
  function setupReveal() { ensureAnchor(); }

  // The sticky button drives the page's real add button so all existing add logic (AJAX add + drawer
  // open for normal products, Kaching's multi-item bundle build for bundles) runs unchanged.
  btn.addEventListener('click', function () {
    var rb = realBtn();
    if (rb && !rb.disabled) rb.click();
  });

  // ---- Re-sync triggers ----
  var t1 = null;
  function schedule() { if (t1) return; t1 = setTimeout(function () { t1 = null; sync(); }, 60); }

  sync();
  [300, 900, 1800, 3000].forEach(function (ms) { setTimeout(sync, ms); }); // Kaching renders late
  window.addEventListener('load', sync);

  // Re-sync when the cart drawer CLOSES (it toggles html.tu-cart-lock). Covers add → remove items →
  // close: the real button is enabled again by then, so re-mirroring un-greys the sticky button.
  var lastLock = document.documentElement.classList.contains('tu-cart-lock');
  try {
    new MutationObserver(function () {
      var lock = document.documentElement.classList.contains('tu-cart-lock');
      if (lock === lastLock) return;
      lastLock = lock;
      if (!lock) setTimeout(sync, 80);
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  } catch (e) {}

  // Variant change → Dawn re-renders the price block.
  if (priceBlock) { try { new MutationObserver(schedule).observe(priceBlock, { childList: true, subtree: true, characterData: true }); } catch (e) {} }

  // Kaching bundle selection changes (clicking a deal bar / picking items).
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[class*="kaching-bundles"]')) {
      setTimeout(sync, 60); setTimeout(sync, 350);
    }
  }, true);

  // Once the Kaching widget exists, observe its class/child changes (bar --selected toggles).
  var tries = 0, kbTimer = setInterval(function () {
    tries++;
    var kb = document.querySelector('.kaching-bundles__bars') || document.querySelector('[class*="kaching-bundles__bar"]');
    if (kb) {
      clearInterval(kbTimer);
      var rootKb = kb.closest('[class*="kaching-bundles"]') || kb;
      try { new MutationObserver(schedule).observe(rootKb, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true }); } catch (e) {}
      sync();
    } else if (tries > 30) { clearInterval(kbTimer); }
  }, 500);
})();
